import {
  AuFlagSvg,
  CaFlagSvg,
  EuFlagSvg,
  SgFlagSvg,
  UkFlagSvg,
  UsFlagSvg,
  ZaFlagSvg,
} from "@ms/gatsby-theme";

import { NavCountriesInterface } from "@/types/navigation";

export const countries: NavCountriesInterface[] = [
  {
    countryCode: "US",
    text: "US",
    displayName: "United States",
    baseUrl: "https://www.manscaped.com",
    Icon: UsFlagSvg,
  },
  {
    countryCode: "CA",
    text: "CA",
    displayName: "Canada",
    baseUrl: "https://ca.manscaped.com",
    Icon: CaFlagSvg,
  },
  {
    countryCode: "EU",
    text: "EUR",
    displayName: "Europe",
    baseUrl: "https://eu.manscaped.com",
    Icon: EuFlagSvg,
  },
  {
    countryCode: "UK",
    text: "UK",
    displayName: "United Kingdom",
    baseUrl: "https://uk.manscaped.com",
    Icon: UkFlagSvg,
  },
  {
    countryCode: "AU",
    text: "AU/NZ",
    displayName: "Australia / New Zealand",
    baseUrl: "https://au.manscaped.com",
    Icon: AuFlagSvg,
  },
  {
    countryCode: "SG",
    text: "SG",
    displayName: "Singapore",
    baseUrl: "https://sg.manscaped.com",
    Icon: SgFlagSvg,
  },
  {
    countryCode: "ZA",
    text: "ZA",
    displayName: "South Africa",
    baseUrl: "https://za.manscaped.com",
    Icon: ZaFlagSvg,
  },
];

/* CONSTANTS */

/* Local Storage */
export const LS_ACCESS_TOKEN = "ms_access_token";

export const LS_DISCOUNT_CODE = "ms_discount_code";

export const LS_SHOPIFY_CART_ID = "ms_shopify_cart_id";

export const LS_PHP_MEMBER = "ms_php_member";

/**
 *  If this constant in Local Storage equals 1, then the ipgeolocation redirect modal will not appear.
 *  We did this so users don't get spammed with redirect modals whenever they switch sites.
 */
export const LS_REDIRECT = "ms_redirect";

export const LS_LANG_REDIRECT = "ms_lang_redirect";

export const LS_PREV_USER = "session_hash";

export const COOKIE_DISCOUNT_IS_DISMISS = "isToastDismissed";

export const SHOP_ALL_SLUG = "shop-all";

const domain = process.env.LOCAL_AUTH_URL
  ? process.env.LOCAL_AUTH_URL.replace("https://", "")
  : process.env.MS_ENVIRONMENT === "production"
  ? ".manscaped.com"
  : ".manscaped.io";

export const COOKIE_OPTIONS = {
  domain: domain,
  maxAge: 24 * 60 * 60,
  path: "/",
};

export const strapiLanguages = process.env.STRAPI_LANGUAGES ? process.env.STRAPI_LANGUAGES : "en";
export const strapiLanguagesArray = strapiLanguages.split(",");

export type SubscriptionCancelSource = "CONTACT_FORM" | "ACCOUNT";
